export const SiteStatusName = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};
